import { render, staticRenderFns } from "./GanttTask.vue?vue&type=template&id=0ef2f3c3&"
import script from "./GanttTask.vue?vue&type=script&lang=js&"
export * from "./GanttTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports